
export const PERSISTENCE_KEYS = {
  session: 'asession',
  hsession: 'hsession'
};
